import { forwardRef } from 'react';

import { Modal, Dialog } from '@hivebrite/design-system/Dialog';
import { type ModalElement, type WidthProps } from '@hivebrite/design-system/Dialog';

import useFrameTheme from 'hb-react/shared/hooks/theme/useFrameTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import { type ModalProps } from './types';

export default forwardRef<
  ModalElement,
  ModalProps & {
    isOpen: boolean;
    shouldUseDialog?: boolean;
    style?: Object;
    width?: WidthProps;
  }
>(
  (
    {
      center,
      children,
      customHeight,
      customZIndex,
      dataTestId,
      enableEscAction,
      isOpen,
      onCloseModal,
      shouldUseDialog,
      screenReadersCloseButtonText,
      width,
      withFullScreenModal = false,
      style,
    },
    ref,
  ) => {
    const frameTheme = useFrameTheme();

    const Element = shouldUseDialog ? Dialog : Modal;

    return (
      <ThemeProvider
        fontBrightness={frameTheme.fontBrightness}
        theme={frameTheme.themeName}
      >
        <Element
          bg={frameTheme.backgroundColor}
          canDismissOnEsc={enableEscAction}
          closeButtonText={screenReadersCloseButtonText}
          center={center}
          dataTestId={dataTestId}
          height={customHeight}
          isModal
          isOpen={isOpen}
          onDismiss={onCloseModal}
          ref={ref}
          width={withFullScreenModal ? { s: '100%', m: '95%' } : width}
          zIndex={customZIndex}
          // To be fixed when we choose between the two or make a V3.
          // @ts-expect-error V1 and V2 types are incompatible.
          style={style}
        >
          {children({
            closeButton: <>{null}</>,
            labelledById: '',
            viewportSize: {},
            isScrollDown: false,
          })}
        </Element>
      </ThemeProvider>
    );
  },
);
